import {emotionStyled, tokens} from '@packages/utilities/styled';
import {VStack} from '../../../Stack';
import Divider from '../../../Divider';

export const ControlsDivider = emotionStyled(Divider)(
  {
    width: tokens.ui.numberInput.controls.width,
    position: 'absolute',
  },
  {
    componentName: 'NumberInputControlsDivider',
  }
);

export const NumberInputTrailingControlsView = emotionStyled(VStack)(
  {
    borderRadius: '0 $2 $2 0',
    boxShadow: '$uiNumberInputDefaultButtonInactive',
    justifyContent: 'center',
    padding: 0,
    height: tokens.ui.numberInput.controls.height,
    width: tokens.ui.numberInput.controls.width,
    hr: {
      pointerEvents: 'none',
    },
  },
  {
    componentName: 'NumberInputControls',
    variants: {
      isDisabled: {
        true: {
          boxShadow: '$uiNumberInputDefaultButtonActive',
        },
      },
      isFocused: {
        true: {
          boxShadow: '$uiNumberInputDefaultButtonActive',
        },
      },
      isError: {
        true: {
          boxShadow: '$uiNumberInputDefaultButtonActive',
        },
      },
    },
  }
);
